export interface LeadStageSummaryRow {
  lead_id: number;
  owner_id?: number | string | null;
  owner_name: string;
  company_name: string | null;
  created_date: string | null;
  last_stage_change_date: string | null;
  modified_date: string | null;
  mql: number;
  non_contactable: number;
  open: number;
  total_time: number;
  final_stage_name: string | null;
}

export interface LeadStageSummaryPaginatedResponse {
  limit: number;
  page_no: number;
  total_count: number;
  total_pages: number;
  list: LeadStageSummaryRow[];
  probability_stage_summary?: LeadPipelineProbabilityStageSummaryGroup[];
  averages: LeadStageAverages;
  section: LeadSection;
}

export interface LeadStageSummaryListResponse {
  limit: number;
  page_no: number;
  total_count: number;
  total_pages: number;
  list: LeadStageSummaryRow[];
}

export interface LeadStageAveragesResponse {
  averages: LeadStageAverages;
  section: LeadSection;
}

export interface LeadPipelineStatusSummaryGroup {
  pipeline_id: number;
  pipeline_name: string;
  total_count: number;
  status_summary: LeadStatusSummaryItem[];
}

export interface LeadStageStatusSummaryResponse {
  total_count: number;
  probability_stage_summary?: LeadPipelineProbabilityStageSummaryGroup[];
  section: LeadSection;
}

export type LeadSection = "open" | "closed" | "all";

export const LEAD_SECTION_FILTER_OPTIONS: Array<{ id: LeadSection; value: string }> = [
  { id: "all", value: "All Leads" },
  { id: "open", value: "Open Leads" },
  { id: "closed", value: "Closed Leads" },
];

export interface LeadStatusSummaryItem {
  final_status: string;
  lead_count: number;
  lead_percent: number;
}

export const LEAD_CONVERSION_PROBABILITIES = [100, 75, 50, 25, 0] as const;
export type LeadConversionProbability =
  (typeof LEAD_CONVERSION_PROBABILITIES)[number];

export interface LeadProbabilityStageCell {
  stage_name: string;
  conversion_probability: number;
  lead_count: number;
}

export interface LeadPipelineProbabilityStageSummaryGroup {
  pipeline_id: number;
  pipeline_name: string;
  total_count: number;
  cells: LeadProbabilityStageCell[];
}

export interface LeadProbabilityPivotRow {
  probability: LeadConversionProbability;
  counts: Record<string, number>;
  rowTotal: number;
}

export interface LeadProbabilityPivotData {
  stages: string[];
  rows: LeadProbabilityPivotRow[];
}

export interface LeadStageAverages {
  mql: number;
  non_contactable: number;
  open: number;
  total_time: number;
}

export interface LeadOwnerLeaderboardRow {
  owner_id: string;
  owner_name: string;
  assigned_count: number;
  won_count: number;
  qualified_count: number;
  converted_count: number;
  conversion_percent: number;
}

export interface LeadOwnerLeaderboardResponse {
  list: LeadOwnerLeaderboardRow[];
}

export type LeadOwnerLeaderboardMetric =
  | "assigned"
  | "won"
  | "qualified"
  | "converted";
